import { z } from "zod"

import { tryCatch } from "@/api/try-catch"

const UNEXPECTED_ERROR_MESSAGE =
  "Une erreur inattendue s'est produite. Veuillez réessayer ou contacter le support."

export async function apiAction<
  I,
  R,
  ZTypes extends z.ZodRawShape,
  ZDefaultTypes extends Record<
    string,
    | string
    | number
    | boolean
    | string[]
    | number[]
    | boolean[]
    | undefined
    | null
    | Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | undefined
        | null
      >
    | Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | undefined
        | null
      >[]
  >,
>(
  formData: I,
  schema: z.ZodObject<
    ZTypes,
    "strip",
    z.ZodTypeAny,
    ZDefaultTypes,
    ZDefaultTypes
  >,
  apiCall: (
    parsed: z.SafeParseReturnType<ZDefaultTypes, ZDefaultTypes>,
  ) => Promise<R>,
): Promise<{ message: string; data?: R }> {
  const parsed = schema.safeParse(formData)
  if (!parsed.success) {
    console.error("ERROR (zod) - Invalid data: " + parsed.error.toString())
    return { message: "Invalid form data" }
  }
  const { error, res } = await tryCatch<R>(() => apiCall(parsed))
  if (error) {
    if (error.cause === "Safe API") {
      return { message: error.message }
    }
    if (error.cause === "Unauthorized") {
      return { message: error.message }
    }
    console.error("API error", error)
    return { message: UNEXPECTED_ERROR_MESSAGE }
  }
  return { message: "Success", data: res }
}

export async function apiActionNoData<R>(
  apiCall: () => Promise<R>,
): Promise<{ message: string; data?: R }> {
  const { error, res } = await tryCatch<R>(apiCall)
  if (error) {
    if (error.cause === "Safe API") {
      return { message: error.message }
    }
    if (error.cause === "Unauthorized") {
      return { message: error.message }
    }
    console.error("API error", error)
    return { message: UNEXPECTED_ERROR_MESSAGE }
  }
  return { message: "Success", data: res }
}
